// extracted by mini-css-extract-plugin
export default {"backdrop":"FullScreenImageOverlay_backdrop__xOSFA","modal":"FullScreenImageOverlay_modal__prjyG","fullImage":"FullScreenImageOverlay_fullImage__njIw2"};